module.exports = __webpack_public_path__ + "img/BB-RCB-DEF4.50d95214.jpg";